import { ApolloClient, InMemoryCache, HttpLink, from } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'

export function createApolloClient () {
    const httpLink = new HttpLink({
        uri: `${process.env.REACT_APP_BACKEND}/hasura-handler`,
        credentials: 'include',
    })

    // Em prod o frontend e o backend são cross-site; cookie SameSite=Lax
    // não acompanha o POST. Envia o token salvo no redirect via Bearer.
    const authLink = setContext((_, { headers }) => {
        const token = localStorage.getItem('accessToken')
        return {
            headers: {
                ...headers,
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
        }
    })

    const errorLink = onError(({ networkError, graphQLErrors }) => {
        if (graphQLErrors && graphQLErrors.length) {
            console.error('[apollo] GraphQL errors:', graphQLErrors)
        }
        if (networkError) {
            console.error('[apollo] Network error:', networkError)
        }
    })

    return new ApolloClient({
        link: from([errorLink, authLink, httpLink]),
        cache: new InMemoryCache(),
        connectToDevTools: true,
    })
}

export default createApolloClient
